import ons from "onsenui";
import React from "react";
import * as Ons from "react-onsenui";
import { ConvertImportedVisit } from "../messages/Visit";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { CHEVRON_RIGHT_SVG, MAP_SVG } from "../utils/svgs";
import { Center } from "./Center";
import { AppButton } from "./Generic/AppButton";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "./Generic/AppCard";
import { AppIcon } from "./Generic/AppIcon";
import { AppList, AppListItem } from "./Generic/AppList";
import { PhoneInput } from "./PhoneInput";
import ScaffoldTitle from "./Scaffold/components/ScaffoldTitle";
import Scaffold from "./Scaffold/Scaffold";

const DEFAULT_COUNTRY = "US";

interface ConvertImportedVisitScreenProps {
  patientName: string;
  patientPhoneNumber: string;
  convertResponse: ConvertImportedVisit | null;
  isLoading: boolean;
  onClickConvert: (patientAddress: string | null) => void;
  onChangePhoneNumber: (patientPhoneNumber: string) => void;
  onSubmitPhoneNumber: () => void;
  onBackClick: () => void;
}

export class ConvertImportedVisitScreen extends React.Component<ConvertImportedVisitScreenProps> {
  componentDidUpdate() {
    if (this.props.convertResponse !== null && this.props.convertResponse.success) {
      return this.props.onBackClick();
    }

    if (
      this.props.convertResponse !== null &&
      this.props.convertResponse.candidatePatientAddresses.length === 0
    ) {
      ons.notification.alert({
        animation: "none",
        modifier: "material",
        title: "Wrong Phone Number",
        message: translate(STRINGS.FAILED_TO_IDENTIFY_PATIENT),
        cancelable: true,
      });
    }
  }

  renderPhoneInput() {
    if (!this.isInPhoneStage()) {
      return null;
    }

    return (
      <AppCard className="__slideInUp">
        <AppCardHeader>
          <AppCardTitle>{translate(STRINGS.PLEASE_ENTER_THE_PATIENT_PHONE)}</AppCardTitle>
        </AppCardHeader>
        <AppCardContent>
          <div className="__phoneNumberForm">
            <PhoneInput
              rootRef={() => null}
              className="ConvertImportedVisitScreen__phoneInput"
              textClassName="ConvertImportedVisitScreen__phoneInputText"
              placeholderClassName="ConvertImportedVisitScreen__phoneInputPlaceholder"
              defaultCountry={DEFAULT_COUNTRY}
              placeholder={translate(STRINGS.PATIENT_PHONE)}
              value={this.props.patientPhoneNumber}
              onChange={this.props.onChangePhoneNumber}
            />

            <AppButton variant="outline" onClick={() => this.props.onSubmitPhoneNumber()}>
              {translate(STRINGS.SUBMIT)}
            </AppButton>
          </div>
        </AppCardContent>
      </AppCard>
    );
  }

  renderAddressInput() {
    if (this.isInPhoneStage() || this.props.convertResponse === null) {
      return null;
    }

    const addresses = this.props.convertResponse.candidatePatientAddresses;

    return (
      <AppCard className="__slideInUp">
        <AppCardHeader>
          <AppCardTitle>{translate(STRINGS.PLEASE_SELECT_THE_PATIENT_ADDRESS)}</AppCardTitle>
        </AppCardHeader>
        <AppCardContent>
          <AppList>
            {addresses.map((address) => (
              <AppListItem
                key={address}
                leading={MAP_SVG}
                title={address}
                trailing={<AppIcon icon={CHEVRON_RIGHT_SVG} stroke="gray-500" />}
                onClick={() => this.props.onClickConvert(address)}
              />
            ))}
          </AppList>
        </AppCardContent>
      </AppCard>
    );
  }

  isInPhoneStage = () => {
    return (
      this.props.convertResponse === null ||
      this.props.convertResponse.candidatePatientAddresses.length === 0
    );
  };

  render() {
    return (
      <Scaffold
        title={<ScaffoldTitle label={this.props.patientName} />}
        className="ConvertImportedVisit"
        onClickGoBack={() => this.props.onBackClick()}
      >
        <Center>
          <div className="ConvertImportedVisitScreen__wrapper">
            <div className="ConvertImportedVisitScreen__formFields">
              {this.renderPhoneInput()}
              {this.renderAddressInput()}
              {!this.props.isLoading ? null : (
                <div className="ConvertImportedVisitScreen__loading">
                  <Ons.ProgressCircular indeterminate={true} />
                </div>
              )}
            </div>
          </div>
        </Center>
      </Scaffold>
    );
  }
}
